import { createSlice } from "@reduxjs/toolkit"
import { v4 as uuidv4 } from "uuid"

const initialState = {
  polygons: [
    {
      id: uuidv4(),
      points: [],
      flattenedPoints: [],
      isFinished: false,
      label: "Polygon 1"
    }
  ],
  activePolygonIndex: 0,
  shouldUpdateHistory: false
}

export const polygonSlice = createSlice({
  name: "polygon",
  initialState,
  reducers: {
    setPolygons: (state, action) => {
      const { polygons, shouldUpdateHistory = true } = action.payload
      state.polygons = polygons
      state.shouldUpdateHistory = shouldUpdateHistory
    },
    setActivePolygonIndex: (state, action) => {
      state.activePolygonIndex = action.payload
    },
    updatePolygonLabel: (state, action) => {
      const { id, label } = action.payload
      const activePoly = state.polygons.find(p => p.id === id)
      if (!activePoly) return
      activePoly.label = label
    },
    deleteAll: state => {
      state.polygons = initialState.polygons
      state.activePolygonIndex = 0
      state.shouldUpdateHistory = false
    }
  }
})

export const {
  setPolygons,
  setActivePolygonIndex,
  updatePolygonLabel,
  deleteAll
} = polygonSlice.actions

export default polygonSlice.reducer
